/**
 * arbi health  — show server health
 * arbi models  — list available models
 */

import { Command } from 'commander'
import { health as healthOps } from '@arbidocs/sdk'
import { runAction, resolveAuth, printTable } from '../helpers.js'
import { label, bold, status } from '../output.js'

export function registerHealthCommand(program: Command): void {
  program
    .command('health')
    .description('Show server health status')
    .option('--json', 'Output raw JSON for scripting')
    .action((opts: { json?: boolean }) =>
      runAction(async () => {
        const { arbi } = await resolveAuth()
        const data = await healthOps.getHealth(arbi)

        if (opts.json) {
          console.log(JSON.stringify(data, null, 2))
          // Non-zero exit when server is not healthy, so scripts can gate on it.
          if (data.status && data.status.toLowerCase() !== 'healthy') {
            process.exit(2)
          }
          return
        }

        label('Status:', status(data.status))
        if (data.backend_git_hash) label('Backend:', data.backend_git_hash)
        if (data.frontend_docker_version) label('Frontend:', data.frontend_docker_version)

        if (data.services.length > 0) {
          bold('\nServices:')
          for (const s of data.services) {
            console.log(`  ${s.name}: ${status(s.status)}${s.detail ? ` — ${s.detail}` : ''}`)
          }
        }

        if (data.models_health) {
          bold(`\nModels (${data.models_health.application}):`)
          for (const m of data.models_health.models) {
            console.log(`  ${m.model}: ${status(m.status)}${m.detail ? ` — ${m.detail}` : ''}`)
          }
        }
      })()
    )

  program
    .command('models')
    .description('List available AI models')
    .option('--json', 'Output as JSON')
    .action((opts: { json?: boolean }) =>
      runAction(async () => {
        const { arbi } = await resolveAuth()
        const data = await healthOps.getHealthModels(arbi)

        if (opts.json) {
          console.log(JSON.stringify(data.models, null, 2))
          return
        }

        if (data.models.length === 0) {
          console.log('No models available.')
          return
        }

        printTable(
          [
            { header: 'NAME', width: 30, value: (r) => r.model_name as string },
            { header: 'PROVIDER', width: 20, value: (r) => (r.provider as string) ?? '' },
            { header: 'API_TYPE', width: 16, value: (r) => r.api_type as string },
          ],
          data.models
        )
      })()
    )
}
